import React, { useRef } from 'react';
import ProductsSections from '../shared/components/molecules/productsSections/productsSections';
import SectionArticle from '../components/organisms/sectionArticle/sectionArticle';
import TabProducts from "../shared/components/molecules/tabProducts/tabProducts";
import Layout from '../shared/components/organisms/layout/layout';
import SEO from '../shared/components/seo';
import useBrowserMode from '../shared/hooks/useBrowserMode';
import useMobileMode from '../shared/hooks/useMobileMode';
import useHomeLinkMode from "../shared/hooks/useHomeLinkMode"
import { stringUnicode } from '../shared/state/utils/utilities-seo';

const HomeSectionDetailArticle = props => {

  const { isBrowser } = useBrowserMode();
  const { isMobile, currentPage } = useMobileMode();
  const { homeLink } = useHomeLinkMode();

  let _parentNode = isBrowser ? document.querySelector('body') : null;
  const parentNode = _parentNode;
  const articleRef = useRef();
  const path = props.pageContext.path;
  const articleData = props.pageContext.articulo;

  React.useEffect(() => {
    if (parentNode.scrollTop > 0) {
      parentNode.scroll({
        top: 0,
        behavior: 'smooth',
      })
    }
  });

  let seoImg = articleData.imagenArticuloCompleta && articleData.imagenArticuloCompleta[0].fluid.src;
  let res = seoImg.split("?");
  seoImg = res[0];

  let datePublished = "";
  let dateModified = "";
  try {
    datePublished = new Date(articleData.fechaDePublicacion);
    dateModified = new Date(articleData.updatedAt);
  } catch (e) {
    console.error("Error al cambiar la fecha", e);
  }

  let schemaOrgJSONLD = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": homeLink + props.pageContext?.slug
    },
    "headline": stringUnicode(props.pageContext.articulo.metaTitulo),
    "description": stringUnicode(props.pageContext.articulo.metaDescripcion.metaDescripcion),
    "image": seoImg,
    "author": {
      "@type": "Organization",
      "name": "TENA"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Grupo Familia S.A",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png",
        "width": "",
        "height": ""
      }
    },
    "datePublished": datePublished,
    "dateModified": dateModified
  };

  return (
    <Layout isMobile={isMobile} currentPage={currentPage}>
      <SEO
        title={props.pageContext.articulo.metaTitulo}
        description={props.pageContext.articulo.metaDescripcion.metaDescripcion}
        lang={props.pageContext.language}
        script={schemaOrgJSONLD}
        slug={"/" + props.pageContext.slug}
        image={seoImg}
      />
      <article ref={articleRef}>
        <TabProducts tabs={props.pageContext.menu} slug={props.pageContext.parentSlug} />
        <SectionArticle
          ismobile={isMobile}
          article={articleData}
          leafletContent={props.pageContext.queryRegister.nodes[0]}
          products={<ProductsSections
            isMobile={isMobile}
            isCurved={true}
            noCenter={true}
            noFooter={true}
            noHeight={true}
            slug={props.pageContext.parentSlug}
            titleType={'article'}
            productos={articleData.tePuedenInteresar ? articleData.tePuedenInteresar.filter(value => value.nombreProducto) : []}
            articulos={articleData.tePuedenInteresar ? articleData.tePuedenInteresar.filter(value => value.descripcionArticulo) : []}
            title={'TE PUEDEN INTERESAR'}
            destacados={articleData.tePuedenInteresar ? articleData.tePuedenInteresar.find(value => value.elementosHtml) : {}}
          />} />
      </article>
    </Layout>
  )
}

export default HomeSectionDetailArticle;